// Etiquetas legibles del status de una unidad externa.
//
// Fuente única de verdad, en un módulo sin dependencias, porque la consumen
// dos mundos que no deben acoplarse:
//   - el mapa (entity-configs.js → getSubtitle del marker/drawer),
//   - la pantalla de alta (views/ExternalDevices.vue).
// La alternativa —importar entity-configs desde la vista de administración—
// arrastraría icon-registry.js, que hace `import.meta.glob` de los SVGs de los
// 4 temas y lanza si VITE_USE_GENERATED_ICONS no está activo. Un listado CRUD
// no debería poder romperse por la configuración del mapa.
//
// El enum lo emite el backend de external-devices; `reported` significa que ya
// se levantó folio en el CAD y la alerta sigue abierta.
export const EXTERNAL_DEVICE_STATUS_LABEL = {
  up: 'En línea',
  down: 'Fuera de línea',
  alert: 'Alerta',
  reported: 'Reportado',
}

// Fuera de línea como default: un status desconocido no debe leerse como
// "operativo" en una pantalla donde el operador decide a quién despachar.
export function externalDeviceStatusLabel(status) {
  return EXTERNAL_DEVICE_STATUS_LABEL[status] || EXTERNAL_DEVICE_STATUS_LABEL.down
}
